<template>
  <!-- <div
    class="abt_box"
    :style="
      'background-image:url(' +
      require('../../../assets/images/about_bg_1.png') +
      ');'
    "
  >-->
    <div class="abt_box" >
    <div
      class="abt_cent"
    >
      <!-- <div class="abt_top"></div> -->
      <div class="wow bounceInRight animated abt_title">
        <span class="sp_1">{{
          lange == "ch" ? titleObj.a1.ch : titleObj.a1.en
        }}</span>
        <span class="sp_2">EASYTIMES IP</span>
        <span class="sp_3">{{
          lange == "ch" ? titleObj.a2.ch : titleObj.a2.en
        }}</span>
      </div>

      <!-- 内容 start -->
      <div class="abt_nr">
        <div
          class="wow bounceInLeft animated abt_n_title1"
          data-wow-delay="0.2s"
        >
          {{ lange == "ch" ? contact.title1.ch : contact.title1.en }}
        </div>

       <hr style="
               width: 93%;
               float: left;
           ">
        <div class="wow bounceInLeft animated abt_n_cat abt_n_catx" data-wow-delay="0.8s" >
          {{
            lange == "ch"
              ? contact.cat.ch
              : contact.cat.en
          }}
        </div>
        <div
          class="wow bounceInLeft animated abt_n_cat abt_n_l"
          data-wow-delay="1s"
        >
          {{
            lange == "ch"
              ? `优势服务：各类知识产权维权诉讼与仲裁。`
              : `Advantageous services: All kinds of litigation and arbitration related to protection of IPRs`
          }}
        </div>
         <div
                  class="wow bounceInLeft animated abt_n_cat abt_n_l"
                  data-wow-delay="1s"
                >
                {{
                            lange == "ch"
                              ? `特色服务：为初创企业提供知识产权“代管加”服务，充当客户知识产权管家与卫士。`
                              : `Featured services: Services of acting IP manager, especially for the startups, managing and protecting their IPRs.`
                }}
        </div>
         <div
                class="wow bounceInLeft animated abt_n_cat abt_n_l"
                data-wow-delay="1s"
              >
              {{
                          lange == "ch"
                            ? `前沿服务：资本运作相关的知识产权服务，包括科创板知识产权布局与强化，专利侵权筛查与评估；投融资相关知识产权尽职调查与评估等。`
                            : `Frontline services: IPR services related to IPO, especially for hi-tech companies, including IPR layout and enhancement, patent infringement screening and assessment, IPR-related due diligence and assessment associated with investment and financing, etc.`
              }}
        </div>
      </div>
      <!-- <div class="btn">
        <span>{{ lange == "ch" ? yewujishao.btn.ch : yewujishao.btn.en }}</span>
        <img class="x_1" src="@/assets/images/x_1.png" alt="" />
        <img class="x_2" src="@/assets/images/x_5.png" alt="" />
      </div> -->
      <!--<div class="btn">
        <i class="h_x_1"></i>
        <span class="h_x_2">{{
          lange == "ch" ? "联系我们" : "contact us"
        }}</span>
        <img class="h_x_3" src="@/assets/images/t_ico_1.png" alt="" />
      </div>-->
    </div>
    <div class="gao"></div>

  </div>
</template>

<script>
export default {
  name: "AboutCat",
  components: {},
  data() {
    return {
      lange: this.$cookies.getCookie("language"),
      titleObj: {
        a1: {
          ch: "关于",
          en: "ABOUT",
        },
        a2: {
          ch: "我们",
          en: "US",
        },
      },
      contact: {
        title1: {
          ch: "有知识产权需求，就找艺识代知识产权",
          en: "Should you have any need of IP, please contact us!",
        },
        cat: {
          ch: "艺识代知识产权以北京艺识代律师事务所为依托，辅以知识产权数据、咨讯、评估、学术等诸多专业机构与资源支持，以北京市经济技术开发区为区位依托，旨在为科技、文创等领域的广大客户提供“一站式、全方位”知识产权服务，即为客户提供多门类（涉及专利、商标、著作权、商业秘密等）；多流程（涉及登记、申请、复审、行政诉讼、维权诉讼、代为管理等）；多境域（立足国内与国际协作）专业服务。",
          en: `Relying on Beijing EasyTimes Law Offices and based in Beijing Economic Technological Development Area, EasyTimes Intellectual Property (IP) aims at providing the "One-stop and All-around" intellectual property right (IPR) services for clients in the fields of high technology, literary and artistic creation, etc. while utilizing the support from IPR data, consultation, evaluation, academic and other professional institutions and resources. Specifically, we can provide clients with professional services, involving various areas (such as patents, trademarks, copyright, trade secrets, etc.), multiple processes (such as registration, application, re-examination, administrative litigation, litigation for the protection of rights, IP management, etc.) and different jurisdictions (based on domestic and international collaboration).`,
        },
      },
    };
  },
  created() {},
  props: [],
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.abt_box {
  width: 100%;
  min-height: 600px;
  display: block;
  background-color: #f6f8fd;
  position: relative;
  background-repeat: no-repeat;
  background-position: center bottom;
  background-size: 100% auto;
}
.abt_cent {
  width: 90%;
  min-height: 300px;
  display: block;
  margin: 0 0 6% 10%;
  background-color: #fff;
  position: relative;
  background-repeat: no-repeat;
  background-position: 83% center;
  background-size: 13% auto;
}
.abt_top {
  width: 100%;
  height: 30px;
  display: block;
  position: absolute;
  background-color: #fff;
  opacity: 0.7;
  top: -30px;
  left: 0;
}
.abt_title {
  width: 240px;
  height: 240px;
  display: block;
  position: absolute;
  top: -130px;
  right: 15%;
  background-color: #bda67d;
  box-shadow: 0 0 18px rgba(0, 0, 0, 0.2);
}
.abt_n_catx{
  margin: 50px 0px 60px 0;
}
.abt_title > span {
  width: 100%;
  display: block;
  text-align: center;
}
.abt_n_l{
  margin-top: 15px;
  font-size: 14px;
  font-style: italic;
}
.sp_1,
.sp_3 {
  font-size: 48px;
  font-weight: bold;
  color: #fff;
  letter-spacing: 4px;
}
.sp_1 {
  margin-top: 17%;
}
.sp_2 {
  font-size: 20px;
  color: #fff;
}
.imgss {
  width: 20px;
  height: 76px;
  display: block;
  position: absolute;
  left: -16px;
  top: 30%;
}
.abt_nr {
  width: 65%;
  display: block;
  padding: 60px 0 160px 5%;
}
.abt_n_title1 {
  width: 100%;
  display: block;
  font-size: 24px;
  color: #213546;
  font-family: shsb,'Avenir', Helvetica, Arial, sans-serif;
  margin-top: 15px;
}
.abt_n_title2 {
  display: inline-block;
  font-size: 14px;
  color: #bda67d;
  border: 1px solid #bda67d;
  padding: 5px 20px;
  margin: 10px 0 50px 0;
}

.abt_n_cat {
  width: 94%;
  display: block;
  font-size: 16px;
  color: #bda67d;
  line-height: 30px;
}
.gao {
  width: 100%;
  height: 1px;
  display: block;
}

.x_1 {
  width: 85%;
  height: 4px;
  display: block;
  margin-top: 1.2%;
}
.x_2 {
  width: 12%;
  display: block;
  cursor: pointer;
}

.x_6 {
  width: 11%;
  display: block;
  position: absolute;
  top: 12%;
  right: 5%;
}

/* 横线按钮 */
.btn {
  width: 80%;
  height: 34px;
  display: block;
  position: relative;
  padding: 0 0 100px 5%;
}
.h_x_1 {
  width: 70%;
  height: 2px;
  display: block;
  position: absolute;
  background-color: #c28e33;
  top: 18px;
  left: 5%;
}
.h_x_2 {
  display: block;
  position: absolute;
  top: 2px;
  right: 9%;
  font-size: 22px;
  color: #c28e33;
}
.h_x_3 {
  width: 34px;
  height: 34px;
  display: block;
  position: absolute;
  top: 0;
  right: 0;
}

@media only screen and (max-width: 1440px) {
  .abt_nr {
    width: 75%;
  }
  .x_1 {
    width: 70%;
    height: 4px;
    margin-top: 2.4%;
  }
  .x_2 {
    width: 25%;
  }
  .abt_cent {
    background-position: 93% center;
    background-size: 13% auto;
  }
}

@media only screen and (max-width: 1300px) {
  .abt_title {
    width: 200px;
    height: 200px;
    display: block;
    position: absolute;
    top: -160px;
    right: 5%;
    background-color: #bda67d;
    box-shadow: 0 0 18px rgba(0, 0, 0, 0.2);
  }
  .h_x_1 {
    width: 60%;
  }
}
@media only screen and (max-width: 600px) {
  .abt_nr {
    width: 85%;
  }
  .x_1 {
    width: 60%;
    height: 2px;
    margin-top: 3.4%;
  }
  .x_2 {
    width: 35%;
  }
  .h_x_1 {
    width: 50%;
  }
  .sp_2 {
    font-size: 16px;
    color: #fff;
  }
}
@media only screen and (max-width: 425px) {
  .abt_title {
    width: 120px;
    height: 120px;
    top: -65px;
  }
  .sp_1 {
    margin-top: 17%;
  }
  .abt_n_title1 {
    font-size: 16px;
  }
  .abt_n_title2 {
    font-size: 12px;
    margin: 10px 0;
  }
  .abt_n_title3 {
    font-size: 14px;
  }
  .abt_n_cat {
    font-size: 14px;
    line-height: 24px;
    color:#213546;
  }
  .abt_nr {
    padding: 60px 5% 30px 5%;
  }
  .abt_cent {
    background-size: 0;
  }
  .abt_n_title3 {
    margin: 0 0 30px 0;
  }

  .h_x_1 {
    width: 50%;
  }
  .h_x_2 {
    right: 14%;
    font-size:16px;
    top: 7%;
  }
  .abt_n_l{
    margin-top: 15px;
    font-size: 12px;
    font-style: italic;
    color:#bda67d;
  }
  .abt_n_catx{
    margin: 35px 0px 40px 0;
  }
  .h_x_3 {
    width: 20px;
    height: 20px;
    display: block;
    position: absolute;
    top: 12%;
    right: 3%;
  }
  .btn{
    padding: 0 0 25px 5%;
  }
  .sp_1,
  .sp_3 {
    font-size: 22px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/AboutUs/component/AboutCat.vue